/**
 * Execution Slice — Types & Initial State
 *
 * Matches Smithy model: FintechLastMileBeaconSmithyModel/model/fetch-executions.smithy
 * API: POST /executions/fetch (1–100 IDs per call)
 */
import { StatusTimelineEntry } from '../payment/paymentState';

/** Full execution response from POST /executions/fetch. */
export interface ExecutionResponse {
  id: string;
  parentWorkflowId: string | null;
  paymentIds: string[] | null;
  executionType: string;
  executionTags: string[] | null;
  paymentType: string | null;
  pluginName: string | null;
  dataSource: string | null;
  beaconExecutionStatus: string;
  beaconExecutionState: string | null;
  firstStatusAt: string | null;
  totalLatencyMs: number | null;
  statusTimeline: StatusTimelineEntry[];
  errorInfo: string | null;
  createdAt: string;
  updatedAt: string;
}

/** Response from POST /executions/fetch. */
export interface FetchExecutionsResponse {
  executions: ExecutionResponse[];
  notFound: string[];
}

/** Redux slice state. */
export interface ExecutionState {
  data: ExecutionResponse | null;
  loading: boolean;
  error: string | null;
  currentRequestId: string | null;
}

export const executionInitialState: ExecutionState = {
  data: null,
  loading: false,
  error: null,
  currentRequestId: null,
};
